export function checkPrototype(Vue) {
  if (!Vue.prototype.hasOwnProperty.call("$hcentrix")) {
    Vue.prototype.$hcentrix = {};
  }
}

export function checkOptions(options) {
  return options != null ? options : {};
}
